import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHome = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Home</title>
    <path
      d="M5.713 12.856v15.336c0 .369.299.663.667.663h5.524a.667.667 0 0 0 .666-.666V21.47c0-2.039 1.535-3.692 3.429-3.692 1.893 0 3.428 1.653 3.428 3.692v6.718c0 .368.299.666.667.666h5.523a.664.664 0 0 0 .667-.663V12.856"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M2.285 15.714 15.999 2.571l13.715 13.143"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoHome;
